// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles-module__icon___2i8iC","active":"styles-module__active___ZoagF"};